enum InvoiceStatus {
	OPEN = 'open', // concept or registered (external)
	GENERATED = 'generated', // generated or agreed (external)
	SENT = 'sent',
	CLOSED = 'closed',
	PAID = 'paid'
}

export default InvoiceStatus
